
@switch (columnId) {
  @case (MerchantEventOrderByEnum.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case ('token') {
    <lib-text-table-column>
      {{ element.token }}
    </lib-text-table-column>
  }
  @case (MerchantEventOrderByEnum.EventType) {
    <lib-text-table-column>
      {{ element.eventType }}
    </lib-text-table-column>
  }
  @case (MerchantEventOrderByEnum.CreatedUtc) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @default {
  }
}





